import { Route, Routes } from 'react-router-dom'
import { Home } from '../../FontFree/Home/Home.jsx'
import { Project } from '../../FontFree/Project/Project.jsx'
import { useEffect } from 'react';



export const FontFreeRouter = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the new page
    }, []);

    return (
        <Routes>
            <Route path='/' element={<Home />}></Route>
            <Route path='/Project/:id' element={<Project />}></Route>
        </Routes>
    )
}